export default __webpack_public_path__ + "static/media/item-5.c1354bdd.png";